import ecommProTag from "@/Assets/images/ecommProTag.svg";
import ecomEliteTag from "@/Assets/images/ecommEliteLogo.svg";

const ECOMM_TEXT_OR_ICON = {
  ecomm: {
    text: "Essential",
    icon: null,
  },
  ecomm_plus: {
    text: "",
    icon: ecommProTag,
  },
  ecomm_elite: {
    text: "",
    icon: ecomEliteTag,
  },
  essential: {
    text: "Essential",
    icon: null,
  },
  pro: {
    text: "",
    icon: ecommProTag,
  },
  elite: {
    text: "",
    icon: ecomEliteTag,
  },
};

type SubscriptionType = "ecomm" | "ecomm_plus" | "ecomm_elite" | "essential" | "pro" | "elite";

const getEcommTextOrIcon = (subscriptionType: SubscriptionType) => ECOMM_TEXT_OR_ICON[subscriptionType];

export default getEcommTextOrIcon;
